import { MarketplaceConfig } from "TypesAndInterfaces";
import * as jose from "jose";

export const EMAIL_FORMAT =
  /^[\w-\\.\\+]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PASSWORD_FORMAT =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[\W]).{8,}$/;

export const URL_FORMAT = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}/;

export const verifyToken = async (token?: string) => {
  let result = true;
  const authToken = token || localStorage.getItem("authToken") || "";
  try {
    const jwt = jose.decodeJwt(authToken);
    const currentTime = Math.floor(Date.now() / 1000);
    const { exp } = jwt;
    if (exp) {
      if (exp < currentTime) {
        result = false;
      }
    } else {
      result = false;
    }
  } catch (error) {
    result = false;
    console.log(error);
  }
  return result;
};

export const initialState: MarketplaceConfig = {
  account: {
    useSubscription: false,
    useCommision: true,
    hopReturnUrl: "",
    manageBlockPaymentFlags: true,
    marketplaceOperatorEmails: [],
    accountPartialSyncScheduler: undefined,
    accountFullSyncScheduler: undefined,
    invoiceSyncScheduler: undefined,
    noOfSellerQuestions: 3,
    unsuspendNewShops: true,
    locale: "",
    maxInvoiceRetryCount: 3,
    useChannels: undefined,
    miraklSsoEnabled: false,
    onlyIdReferenceForBeneficiary: false,
    usePreBalancePlatforms: false,
  },
  mirakl: {
    key: "",
    url: "",
    ssoClientId: "",
    ssoClientSecret: "",
  },
  blacklists: {
    shops: [],
    invoices: [],
  }
};
